export default {
    AMOUNT:'No. of shares',
    PRICE:'Price per share',
    ISSUED_DATE:'Issued date',
    SHARE_CLASS:'Class',
    SELECT_PLACEHOLDER: 'Search or select from this list',
    PLACEHOLDER_NUMBER:'Enter a number',
    PLACEHOLDER_DATE:'dd/mm/yyyy',

}